module.exports = __webpack_public_path__ + "static/uw-madison-red-63921165df3898258fb38cfbe440d328.jpg";